import React from 'react';
import Language from './Language.jsx';
import { connect } from 'react-redux';
import { removeLanguage } from './actions.js';
import NewLanguageForm from './NewLanguageForm';

const LanguageList = ({ language = [], onRemovePressed }) => {
    return(
    <div>
        
        <NewLanguageForm />
        <div className="container mb-3">
            {language.map(language => <Language language={language.language} onRemovePressed={onRemovePressed}/>)}
        </div>
    </div>
    )
}

const mapStateToProps = state => ({
    language: state.language,
});

const mapDispatchToProps = dispatch => ({
    onRemovePressed: language => dispatch(removeLanguage(language)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageList);